import { Link } from "react-router-dom";

import React from "react";
import { Container } from "./Container";
import Language from "./LanguageDropdown"

import logo from "../logo.svg"

// Translation
import { useTranslation } from "react-i18next";

import {dataFR} from "../assets/data/fr"
import {dataEN} from "../assets/data/en"
import {dataNL} from "../assets/data/nl"

function Footer() {

  const { i18n } = useTranslation();

  let data = dataFR;
  if (i18n.language === "fr") {
    data = dataFR;
  } else if (i18n.language === "en") {
    data = dataEN;
  } else if (i18n.language ==="nl"){
    data = dataNL;
  }

  const navigation = data.navigation

  return (
    <div className="relative">
      <Container className="p-8">
        <div className="grid max-w-screen-xl grid-cols-1 gap-10 pt-10 mx-auto mt-5 border-t border-gray-100 dark:border-trueGray-700 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <div>
              <Link
                to="/"
                className="flex items-center space-x-2 text-2xl font-medium text-green-600 dark:text-gray-100"
              >
                <img
                  src={logo}
                  alt="N"
                  width="32"
                  height="32"
                  className="w-8"
                  loading="lazy"
                />
                <span>Pharma Manufacturing</span>
              </Link>
            </div>
            <div className="max-w-md mt-4 text-gray-500 dark:text-gray-400">
              Pharma Manufacturing : Fabrication de compléments alimentaires et produits diététiques sur mesure.
              Expertise pharmaceutique depuis 1988. Qualité garantie par des professionnels et des équipements de pointe.
            </div>
          </div>

          <div className="flex gap-6">
            <div className="flex flex-wrap w-full -mt-2 -ml-3 lg:ml-0">
              {navigation.map((item, index) => (
                <Link
                  key={index}
                  to={item.href}
                  className="w-full px-4 py-2 text-gray-500 rounded-md dark:text-gray-300 hover:text-green-400 focus:text-green-400 focus:bg-green-100 focus:outline-none dark:focus:bg-trueGray-700"
                >
                  {item.label}
                </Link>
              ))}
              
            </div>
            <Language/>
          </div>
          <div>

          </div>

        </div>

        <div className="my-10 text-sm text-center text-gray-600 dark:text-gray-400 flex flex-col">
          Copyright © {new Date().getFullYear()}.

        </div>
      </Container>
    
    </div>
  );
}

export default Footer;

